import { List, Map as ImmMap } from 'immutable';
import { FETCH_ERROR, RECEIVE_PRODUCTS, IS_FETCHING } from './constants';

export const initialState = new ImmMap({
	fetchCounter: 0,
	fetchError: undefined,
	productSearchResults: new List(),
	products: new ImmMap(),
	searchResultsHeader: new ImmMap(),
});

const ProductSearchReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_ERROR:
			return state.set('fetchError', action.fetchError);
		case RECEIVE_PRODUCTS: {
			let products;
			if (action.resultHeader && action.resultHeader.page > 0) {
				// Any results after page 0 start concatenating.
				let prevProducts;
				if (action.categoryId != null) {
					// grab previous products from corresponding category id
					prevProducts = state.getIn(['products', action.categoryId, 'products'], new List());
				} else {
					// grab previous products from search
					prevProducts = state.getIn(['products', action.term, 'products'], new List());
				}
				products = prevProducts.concat(new List(action.products));
			} else {
				// page 0. just set state to returned list of products
				products = new List(action.products);
			}
			const { lastFetchTime } = action;
			if (action.categoryId == null) {
				// assume we're doing a search
				return state.mergeIn(['products', action.term], {
					lastFetchTime,
					products,
					resultHeader: action.resultHeader,
				});
			}
			return state.mergeIn(['products', action.categoryId], {
				lastFetchTime,
				products,
				resultHeader: action.resultHeader,
			});
		}
		case IS_FETCHING: {
			const counter = state.get('fetchCounter');
			return action.increment
				? state.set('fetchCounter', counter + 1)
				: state.set('fetchCounter', counter - 1);
		}
		default:
			return state;
	}
};

export default ProductSearchReducer;
